export default __webpack_public_path__ + "b7d537738f8cda939d10ebfdde07430e.jpg";